import React from 'react';

interface IIconMonetizationDocsProps {
  className?: string;
  style?: React.CSSProperties;
  width?: number | string;
  height?: number | string;
}

const IconMonetizationDocs: React.FC<IIconMonetizationDocsProps> = ({
  className,
  style,
  width = 124,
  height = 124,
}) => {
  return (
    <svg
      className={className}
      style={style}
      width={width}
      height={height}
      viewBox="0 0 124 124"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g className="icon-monetization-docs-svg-group">
        <circle cx="65.1016"
          cy="57.8667"
          r="36.8125"
          stroke="#E2E2E2"
          strokeWidth="7.75"
        />
        <path
          d="M65.1055 37.9106C67.5166 37.9284 69.6916 38.3904 71.6182 39.3091C73.56 40.2102 75.1705 41.511 76.4395 43.2075L76.6357 43.4741C77.6012 44.8206 78.3068 46.363 78.7568 48.0942C79.01 49.0684 78.3446 49.9855 77.4102 50.1597L75.1484 50.5815C74.1683 50.7642 73.3036 50.0968 73.0537 49.2241C72.7783 48.2615 72.3545 47.4152 71.7861 46.6802L71.7803 46.6724C71.0137 45.6457 70.0553 44.8621 68.8984 44.3169L68.8926 44.3149C67.7321 43.7519 66.4522 43.4582 65.0459 43.4419C63.6962 43.4255 62.4958 43.655 61.4346 44.1177C60.3691 44.5822 59.5401 45.2219 58.9287 46.0298L58.9258 46.0337C58.3295 46.8066 58.0293 47.6973 58.0293 48.729C58.0293 49.7578 58.3047 50.5345 58.8076 51.1138C59.3617 51.7348 60.0415 52.2362 60.8545 52.6167L61.5137 52.895C62.1671 53.1601 62.8055 53.3864 63.4287 53.5747L63.4316 53.5757L70.0615 55.6167L70.668 55.8052C71.2946 56.0105 71.982 56.2641 72.7295 56.5649H72.7285C73.7843 56.9832 74.7997 57.5713 75.7744 58.3247H75.7734C76.7864 59.0903 77.6139 60.1082 78.2607 61.3618H78.2598C78.9285 62.6406 79.2451 64.2218 79.2451 66.0747C79.2451 67.9412 78.892 69.6245 78.1699 71.1108C77.4705 72.5839 76.4867 73.8249 75.2227 74.8276L75.2188 74.8306C73.9629 75.8087 72.5092 76.547 70.8652 77.0483L70.8643 77.0474C69.2224 77.5651 67.4702 77.8227 65.6104 77.8228C63.0686 77.8228 60.757 77.3616 58.6865 76.4272L58.6855 76.4263C56.6333 75.4926 54.9263 74.1598 53.5752 72.4292L53.5713 72.4243C52.4626 70.9714 51.6779 69.3046 51.2129 67.4321C50.9693 66.4511 51.6536 65.5431 52.5918 65.3853L54.8301 65.0093C55.7455 64.8553 56.5685 65.4406 56.8477 66.2544C57.4463 67.9998 58.4461 69.3887 59.8496 70.439C61.5331 71.6693 63.5177 72.2915 65.8281 72.2915C67.3282 72.2915 68.6631 72.0443 69.8418 71.561C71.0344 71.0615 71.9564 70.3628 72.6299 69.4722C73.2892 68.6002 73.627 67.5625 73.627 66.3325C73.6269 65.5678 73.4992 64.9498 73.2695 64.4595L73.2617 64.4419C73.0355 63.9139 72.7217 63.4772 72.3213 63.1235L72.3135 63.1167L72.3057 63.1089C71.8967 62.7191 71.4269 62.3899 70.8945 62.1216C70.3438 61.844 69.7695 61.615 69.1719 61.4351L69.1641 61.4331V61.4321L60.2764 58.6147H60.2744C59.4 58.3348 58.551 57.9929 57.7275 57.5903L57.3682 57.4106C56.4151 56.902 55.5621 56.2734 54.8105 55.5259L54.8057 55.521C54.0404 54.7413 53.4355 53.8168 52.9893 52.7544L52.9873 52.7505C52.5323 51.6482 52.3145 50.3719 52.3145 48.936C52.3145 46.6334 52.8716 44.6349 54.0146 42.9712L54.0156 42.9702C55.1612 41.3096 56.7075 40.0452 58.6387 39.1772C60.5657 38.3112 62.7252 37.8929 65.1055 37.9106Z"
          fill="#E2E2E2"
          stroke="#E2E2E2"
          strokeWidth="1.1625"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M67.8141 30.7417C68.4561 30.7417 68.9766 31.2622 68.9766 31.9042V42.3667H61.2266V31.9042C61.2266 31.2622 61.747 30.7417 62.3891 30.7417H67.8141Z"
          fill="#E2E2E2"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68.9766 73.3667V83.8292C68.9766 84.4712 68.4561 84.9917 67.8141 84.9917H62.3891C61.747 84.9917 61.2266 84.4712 61.2266 83.8292V73.3667H68.9766Z"
          fill="#E2E2E2"
        />
      </g>
      <circle cx="14.9841"
        cy="16.0168"
        r="5.68333"
        fill="#0A0A0A"
        fillOpacity="0.05"
      />
      <circle cx="120.382"
        cy="76.9834"
        r="3.61667"
        fill="#0A0A0A"
        fillOpacity="0.08"
      />
      <circle cx="48.0505"
        cy="113.15"
        r="5.68333"
        fill="#0A0A0A"
        fillOpacity="0.08"
      />
    </svg>
  );
};

export default IconMonetizationDocs;